import theme from '../../base';

const avatar = {
  bg: theme.colors.neutrals.gray500,
  border: theme.colors.neutrals.gray500,
  badge: {
    bgAdm: theme.colors.neutrals.gray800,
    bgUser: theme.colors.greens.green500,
    foreground: theme.colors.neutrals.white,
  },
};

export default avatar;
